import React, { Component } from 'react'
import { ResourceInfo } from '../../schema/types.d'

interface Props {
  resource: ResourceInfo.Fragment
  onDetailsClick: () => void
}

class ResourceThumbnail extends Component<Props> {
  render() {
    const resource = this.props.resource
    return (
      <article className="shadow-1 w-30 pa3 mr2 mb2 bg-near-white">
        <div className="dt">
          <div className="dtc v-mid">
            <img
              alt=""
              src={resource.thumbnailUrl}
              className="br-100 h3 w3 dib"
              title={`Photo of ${resource.fullName}`}
            />
          </div>
          <div className="dtc v-mid pl4">
            <h1 className="f6 dim pointer" onClick={this.props.onDetailsClick}>
              {resource.firstName} {resource.lastName}
            </h1>
            <hr className="mw5 bb bw1 b--black-10" />
            <p className="f7 black-50">{resource.title}</p>
            <div className="measure center f7 black-50">
              {resource.laborCategory}
            </div>
            <div className="measure center f7 black-50">{resource.sector}</div>
            <div className="f7 black-50">{resource.office}</div>
          </div>
        </div>
      </article>
    )
  }
}

export default ResourceThumbnail
